/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';


function ModuleFullWidthContainer({
  _id,
  /* _contentTypeId, */ title,
  body,
  ctaButton,
  image,
  className,
  themeClassName
}) {

  return (
 <></>
  );
}

export default ModuleFullWidthContainer;
